export const config = {
  apiUrl: process.env.REACT_APP_API_URL,
};
export const fuelTypes = [
  {
    id: "1",
    name: "Gasoline",
  },
  {
    id: "2",
    name: "Diesel Fuel",
  },
  {
    id: "3",
    name: "Bio-diesel",
  },
  {
    id: "4",
    name: "Hybrid",
  },
];
export const transmission = [
  {
    id: "1",
    name: "Automatic",
  },
  {
    id: "2",
    name: "Manual",
  },
];
export const countries = [
  {
    id: 3,
    name: "United Arab Emirates",
    code2: "AE",
    code3: "UAE",
    mobile_code: "+971",
  },
  {
    id: 148,
    name: "Lebanon",
    code2: "LB",
    code3: "LBN",
    mobile_code: "+961",
  },
  {
    id: 2,
    name: "Andorra",
    code2: "AD",
    code3: "AND",
    mobile_code: "+376",
  },
  {
    id: 4,
    name: "Afghanistan",
    code2: "AF",
    code3: "AFG",
    mobile_code: "+93",
  },
  {
    id: 5,
    name: "Antigua and Barbuda",
    code2: "AG",
    code3: "ATG",
    mobile_code: "+1 268",
  },
  {
    id: 6,
    name: "Anguilla",
    code2: "AI",
    code3: "AIA",
    mobile_code: "+1 264",
  },
  {
    id: 7,
    name: "Anguilla",
    code2: "AI",
    code3: "AFI",
    mobile_code: "",
  },
  {
    id: 8,
    name: "Albania",
    code2: "AL",
    code3: "ALB",
    mobile_code: "+355",
  },
  {
    id: 9,
    name: "Armenia",
    code2: "AM",
    code3: "ARM",
    mobile_code: "+374",
  },
  {
    id: 11,
    name: "Angola",
    code2: "AO",
    code3: "AGO",
    mobile_code: "+244",
  },
  {
    id: 12,
    name: "Antarctica",
    code2: "AQ",
    code3: "ATA",
    mobile_code: "+672",
  },
  {
    id: 13,
    name: "Argentina",
    code2: "AR",
    code3: "ARG",
    mobile_code: "+54",
  },
  {
    id: 14,
    name: "American Samoa",
    code2: "AS",
    code3: "ASM",
    mobile_code: "+1 684",
  },
  {
    id: 15,
    name: "Austria",
    code2: "AT",
    code3: "AUT",
    mobile_code: "+43",
  },
  {
    id: 16,
    name: "Australia",
    code2: "AU",
    code3: "AUS",
    mobile_code: "+61",
  },
  {
    id: 17,
    name: "Aruba",
    code2: "AW",
    code3: "ABW",
    mobile_code: "+297",
  },
  {
    id: 18,
    name: "Åland Islands",
    code2: "AX",
    code3: "ALA",
    mobile_code: "+358",
  },
  {
    id: 19,
    name: "Azerbaijan",
    code2: "AZ",
    code3: "AZE",
    mobile_code: "+994",
  },
  {
    id: 20,
    name: "Bosnia and Herzegovina",
    code2: "BA",
    code3: "BIH",
    mobile_code: "+387",
  },
  {
    id: 21,
    name: "Barbados",
    code2: "BB",
    code3: "BRB",
    mobile_code: "+1 246",
  },
  {
    id: 22,
    name: "Bangladesh",
    code2: "BD",
    code3: "BGD",
    mobile_code: "+880",
  },
  {
    id: 23,
    name: "Belgium",
    code2: "BE",
    code3: "BEL",
    mobile_code: "+32",
  },
  {
    id: 24,
    name: "Burkina Faso",
    code2: "BF",
    code3: "BFA",
    mobile_code: "+226",
  },
  {
    id: 25,
    name: "Bulgaria",
    code2: "BG",
    code3: "BGR",
    mobile_code: "+359",
  },
  {
    id: 26,
    name: "Bahrain",
    code2: "BH",
    code3: "BHR",
    mobile_code: "+973",
  },
  {
    id: 27,
    name: "Burundi",
    code2: "BI",
    code3: "BDI",
    mobile_code: "+257",
  },
  {
    id: 28,
    name: "Benin",
    code2: "BJ",
    code3: "BEN",
    mobile_code: "+229",
  },
  {
    id: 29,
    name: "Saint Barthélemy",
    code2: "BL",
    code3: "BLM",
    mobile_code: "+590",
  },
  {
    id: 30,
    name: "Bermuda",
    code2: "BM",
    code3: "BMU",
    mobile_code: "+1 441",
  },
  {
    id: 31,
    name: "Brunei Darussalam",
    code2: "BN",
    code3: "BRN",
    mobile_code: "+673",
  },
  {
    id: 32,
    name: "Bolivia",
    code2: "BO",
    code3: "BOL",
    mobile_code: "+591",
  },
  {
    id: 33,
    name: "Bonaire, Sint Eustatius and Saba",
    code2: "BQ",
    code3: "BES",
    mobile_code: "+599",
  },
  {
    id: 34,
    name: "Bonaire, Sint Eustatius and Saba",
    code2: "BQ",
    code3: "ATB",
    mobile_code: "",
  },
  {
    id: 35,
    name: "Brazil",
    code2: "BR",
    code3: "BRA",
    mobile_code: "+55",
  },
  {
    id: 36,
    name: "Bahamas",
    code2: "BS",
    code3: "BHS",
    mobile_code: "+1 242",
  },
  {
    id: 37,
    name: "Bhutan",
    code2: "BT",
    code3: "BTN",
    mobile_code: "+975",
  },
  {
    id: 39,
    name: "Bouvet Island",
    code2: "BV",
    code3: "BVT",
    mobile_code: "",
  },
  {
    id: 40,
    name: "Botswana",
    code2: "BW",
    code3: "BWA",
    mobile_code: "+267",
  },
  {
    id: 41,
    name: "Belarus",
    code2: "BY",
    code3: "BLR",
    mobile_code: "+375",
  },
  {
    id: 42,
    name: "Belarus",
    code2: "BY",
    code3: "BYS",
    mobile_code: "",
  },
  {
    id: 43,
    name: "Belize",
    code2: "BZ",
    code3: "BLZ",
    mobile_code: "+501",
  },
  {
    id: 44,
    name: "Canada",
    code2: "CA",
    code3: "CAN",
    mobile_code: "+1",
  },
  {
    id: 45,
    name: "Cocos (Keeling) Islands",
    code2: "CC",
    code3: "CCK",
    mobile_code: "+61",
  },
  {
    id: 46,
    name: "Democratic Republic of the Congo",
    code2: "CD",
    code3: "COD",
    mobile_code: "+243",
  },
  {
    id: 47,
    name: "Central African Republic",
    code2: "CF",
    code3: "CAF",
    mobile_code: "+236",
  },
  {
    id: 48,
    name: "Republic of the Congo",
    code2: "CG",
    code3: "COG",
    mobile_code: "+242",
  },
  {
    id: 49,
    name: "Switzerland",
    code2: "CH",
    code3: "CHE",
    mobile_code: "+41",
  },
  {
    id: 50,
    name: "Cote D'Ivoire",
    code2: "CI",
    code3: "CIV",
    mobile_code: "+225",
  },
  {
    id: 51,
    name: "Cook Islands",
    code2: "CK",
    code3: "COK",
    mobile_code: "+682",
  },
  {
    id: 52,
    name: "Chile",
    code2: "CL",
    code3: "CHL",
    mobile_code: "+56",
  },
  {
    id: 53,
    name: "Cameroon",
    code2: "CM",
    code3: "CMR",
    mobile_code: "+237",
  },
  {
    id: 54,
    name: "People's Republic of China",
    code2: "CN",
    code3: "CHN",
    mobile_code: "+86",
  },
  {
    id: 55,
    name: "Colombia",
    code2: "CO",
    code3: "COL",
    mobile_code: "+57",
  },
  {
    id: 57,
    name: "Costa Rica",
    code2: "CR",
    code3: "CRI",
    mobile_code: "+506",
  },
  {
    id: 61,
    name: "Cuba",
    code2: "CU",
    code3: "CUB",
    mobile_code: "+53",
  },
  {
    id: 62,
    name: "Cape Verde",
    code2: "CV",
    code3: "CPV",
    mobile_code: "+238",
  },
  {
    id: 63,
    name: "Curaçao",
    code2: "CW",
    code3: "CUW",
    mobile_code: "+599",
  },
  {
    id: 64,
    name: "Christmas Island",
    code2: "CX",
    code3: "CXR",
    mobile_code: "+61",
  },
  {
    id: 65,
    name: "Cyprus",
    code2: "CY",
    code3: "CYP",
    mobile_code: "+357",
  },
  {
    id: 66,
    name: "Czech Republic",
    code2: "CZ",
    code3: "CZE",
    mobile_code: "+420",
  },
  {
    id: 68,
    name: "Germany",
    code2: "DE",
    code3: "DEU",
    mobile_code: "+49",
  },
  {
    id: 70,
    name: "Djibouti",
    code2: "DJ",
    code3: "DJI",
    mobile_code: "+253",
  },
  {
    id: 71,
    name: "Denmark",
    code2: "DK",
    code3: "DNK",
    mobile_code: "+45",
  },
  {
    id: 72,
    name: "Dominica",
    code2: "DM",
    code3: "DMA",
    mobile_code: "+1 767",
  },
  {
    id: 73,
    name: "Dominican Republic",
    code2: "DO",
    code3: "DOM",
    mobile_code: "+1 809",
  },
  {
    id: 75,
    name: "Algeria",
    code2: "DZ",
    code3: "DZA",
    mobile_code: "+213",
  },
  {
    id: 77,
    name: "Ecuador",
    code2: "EC",
    code3: "ECU",
    mobile_code: "+593",
  },
  {
    id: 78,
    name: "Estonia",
    code2: "EE",
    code3: "EST",
    mobile_code: "+372",
  },
  {
    id: 79,
    name: "Egypt",
    code2: "EG",
    code3: "EGY",
    mobile_code: "+20",
  },
  {
    id: 80,
    name: "Western Sahara",
    code2: "EH",
    code3: "ESH",
    mobile_code: "+212",
  },
  {
    id: 81,
    name: "Eritrea",
    code2: "ER",
    code3: "ERI",
    mobile_code: "+291",
  },
  {
    id: 82,
    name: "Spain",
    code2: "ES",
    code3: "ESP",
    mobile_code: "+34",
  },
  {
    id: 83,
    name: "Ethiopia",
    code2: "ET",
    code3: "ETH",
    mobile_code: "+251",
  },
  {
    id: 85,
    name: "Finland",
    code2: "FI",
    code3: "FIN",
    mobile_code: "+358",
  },
  {
    id: 86,
    name: "Fiji",
    code2: "FJ",
    code3: "FJI",
    mobile_code: "+679",
  },
  {
    id: 87,
    name: "Falkland Islands (Malvinas)",
    code2: "FK",
    code3: "FLK",
    mobile_code: "+500",
  },
  {
    id: 88,
    name: "Micronesia, Federated States of",
    code2: "FM",
    code3: "FSM",
    mobile_code: "+691",
  },
  {
    id: 89,
    name: "Faroe Islands",
    code2: "FO",
    code3: "FRO",
    mobile_code: "+298",
  },
  {
    id: 91,
    name: "France",
    code2: "FR",
    code3: "FRA",
    mobile_code: "+33",
  },
  {
    id: 93,
    name: "Gabon",
    code2: "GA",
    code3: "GAB",
    mobile_code: "+241",
  },
  {
    id: 94,
    name: "United Kingdom",
    code2: "GB",
    code3: "GBR",
    mobile_code: "+44",
  },
  {
    id: 95,
    name: "Grenada",
    code2: "GD",
    code3: "GRD",
    mobile_code: "+473",
  },
  {
    id: 96,
    name: "Georgia",
    code2: "GE",
    code3: "GEO",
    mobile_code: "+995",
  },
  {
    id: 97,
    name: "Georgia",
    code2: "GE",
    code3: "GEL",
    mobile_code: "",
  },
  {
    id: 98,
    name: "French Guiana",
    code2: "GF",
    code3: "GUF",
    mobile_code: "+594",
  },
  {
    id: 99,
    name: "Guernsey",
    code2: "GG",
    code3: "GGY",
    mobile_code: "+44",
  },
  {
    id: 100,
    name: "Ghana",
    code2: "GH",
    code3: "GHA",
    mobile_code: "+233",
  },
  {
    id: 101,
    name: "Gibraltar",
    code2: "GI",
    code3: "GIB",
    mobile_code: "+350",
  },
  {
    id: 102,
    name: "Greenland",
    code2: "GL",
    code3: "GRL",
    mobile_code: "+299",
  },
  {
    id: 103,
    name: "Republic of The Gambia",
    code2: "GM",
    code3: "GMB",
    mobile_code: "+220",
  },
  {
    id: 104,
    name: "Guinea",
    code2: "GN",
    code3: "GIN",
    mobile_code: "+224",
  },
  {
    id: 105,
    name: "Guadeloupe",
    code2: "GP",
    code3: "GLP",
    mobile_code: "+590",
  },
  {
    id: 106,
    name: "Equatorial Guinea",
    code2: "GQ",
    code3: "GNQ",
    mobile_code: "+240",
  },
  {
    id: 107,
    name: "Greece",
    code2: "GR",
    code3: "GRC",
    mobile_code: "+30",
  },
  {
    id: 108,
    name: "South Georgia and the South Sandwich Islands",
    code2: "GS",
    code3: "SGS",
    mobile_code: "",
  },
  {
    id: 109,
    name: "Guatemala",
    code2: "GT",
    code3: "GTM",
    mobile_code: "+502",
  },
  {
    id: 110,
    name: "Guam",
    code2: "GU",
    code3: "GUM",
    mobile_code: "+1 671",
  },
  {
    id: 111,
    name: "Guinea-Bissau",
    code2: "GW",
    code3: "GNB",
    mobile_code: "+245",
  },
  {
    id: 112,
    name: "Guyana",
    code2: "GY",
    code3: "GUY",
    mobile_code: "+592",
  },
  {
    id: 113,
    name: "Hong Kong",
    code2: "HK",
    code3: "HKG",
    mobile_code: "+852",
  },
  {
    id: 114,
    name: "Heard Island and McDonald Islands",
    code2: "HM",
    code3: "HMD",
    mobile_code: "",
  },
  {
    id: 115,
    name: "Honduras",
    code2: "HN",
    code3: "HND",
    mobile_code: "+504",
  },
  {
    id: 116,
    name: "Croatia",
    code2: "HR",
    code3: "HRV",
    mobile_code: "+385",
  },
  {
    id: 117,
    name: "Haiti",
    code2: "HT",
    code3: "HTI",
    mobile_code: "+509",
  },
  {
    id: 118,
    name: "Hungary",
    code2: "HU",
    code3: "HUN",
    mobile_code: "+36",
  },
  {
    id: 121,
    name: "Indonesia",
    code2: "ID",
    code3: "IDN",
    mobile_code: "+62",
  },
  {
    id: 122,
    name: "Ireland",
    code2: "IE",
    code3: "IRL",
    mobile_code: "+353",
  },
  {
    id: 123,
    name: "Israel",
    code2: "IL",
    code3: "ISR",
    mobile_code: "+972",
  },
  {
    id: 124,
    name: "Isle of Man",
    code2: "IM",
    code3: "IMN",
    mobile_code: "+44",
  },
  {
    id: 125,
    name: "India",
    code2: "IN",
    code3: "IND",
    mobile_code: "+91",
  },
  {
    id: 126,
    name: "British Indian Ocean Territory",
    code2: "IO",
    code3: "IOT",
    mobile_code: "+246",
  },
  {
    id: 127,
    name: "Iraq",
    code2: "IQ",
    code3: "IRQ",
    mobile_code: "+964",
  },
  {
    id: 128,
    name: "Islamic Republic of Iran",
    code2: "IR",
    code3: "IRN",
    mobile_code: "+98",
  },
  {
    id: 129,
    name: "Iceland",
    code2: "IS",
    code3: "ISL",
    mobile_code: "+354",
  },
  {
    id: 130,
    name: "Italy",
    code2: "IT",
    code3: "ITA",
    mobile_code: "+39",
  },
  {
    id: 131,
    name: "Jersey",
    code2: "JE",
    code3: "JEY",
    mobile_code: "+44",
  },
  {
    id: 132,
    name: "Jamaica",
    code2: "JM",
    code3: "JAM",
    mobile_code: "+1 876",
  },
  {
    id: 133,
    name: "Jordan",
    code2: "JO",
    code3: "JOR",
    mobile_code: "+962",
  },
  {
    id: 134,
    name: "Japan",
    code2: "JP",
    code3: "JPN",
    mobile_code: "+81",
  },
  {
    id: 136,
    name: "Kenya",
    code2: "KE",
    code3: "KEN",
    mobile_code: "+254",
  },
  {
    id: 137,
    name: "Kyrgyzstan",
    code2: "KG",
    code3: "KGZ",
    mobile_code: "+996",
  },
  {
    id: 138,
    name: "Cambodia",
    code2: "KH",
    code3: "KHM",
    mobile_code: "+855",
  },
  {
    id: 139,
    name: "Kiribati",
    code2: "KI",
    code3: "KIR",
    mobile_code: "+686",
  },
  {
    id: 140,
    name: "Comoros",
    code2: "KM",
    code3: "COM",
    mobile_code: "+269",
  },
  {
    id: 141,
    name: "Saint Kitts and Nevis",
    code2: "KN",
    code3: "KNA",
    mobile_code: "+1 869",
  },
  {
    id: 142,
    name: "North Korea",
    code2: "KP",
    code3: "PRK",
    mobile_code: "+850",
  },
  {
    id: 143,
    name: "South Korea",
    code2: "KR",
    code3: "KOR",
    mobile_code: "+82",
  },
  {
    id: 144,
    name: "Kuwait",
    code2: "KW",
    code3: "KWT",
    mobile_code: "+965",
  },
  {
    id: 145,
    name: "Cayman Islands",
    code2: "KY",
    code3: "CYM",
    mobile_code: "+1 345",
  },
  {
    id: 146,
    name: "Kazakhstan",
    code2: "KZ",
    code3: "KAZ",
    mobile_code: "+7",
  },
  {
    id: 147,
    name: "Lao People's Democratic Republic",
    code2: "LA",
    code3: "LAO",
    mobile_code: "+856",
  },
  {
    id: 149,
    name: "Saint Lucia",
    code2: "LC",
    code3: "LCA",
    mobile_code: "+1 758",
  },
  {
    id: 150,
    name: "Liechtenstein",
    code2: "LI",
    code3: "LIE",
    mobile_code: "+423",
  },
  {
    id: 151,
    name: "Sri Lanka",
    code2: "LK",
    code3: "LKA",
    mobile_code: "+94",
  },
  {
    id: 152,
    name: "Liberia",
    code2: "LR",
    code3: "LBR",
    mobile_code: "+231",
  },
  {
    id: 153,
    name: "Lesotho",
    code2: "LS",
    code3: "LSO",
    mobile_code: "+266",
  },
  {
    id: 154,
    name: "Lithuania",
    code2: "LT",
    code3: "LTU",
    mobile_code: "+370",
  },
  {
    id: 155,
    name: "Luxembourg",
    code2: "LU",
    code3: "LUX",
    mobile_code: "+352",
  },
  {
    id: 156,
    name: "Latvia",
    code2: "LV",
    code3: "LVA",
    mobile_code: "+371",
  },
  {
    id: 157,
    name: "Libya",
    code2: "LY",
    code3: "LBY",
    mobile_code: "+218",
  },
  {
    id: 158,
    name: "Morocco",
    code2: "MA",
    code3: "MAR",
    mobile_code: "+212",
  },
  {
    id: 159,
    name: "Monaco",
    code2: "MC",
    code3: "MCO",
    mobile_code: "+377",
  },
  {
    id: 160,
    name: "Moldova, Republic of",
    code2: "MD",
    code3: "MDA",
    mobile_code: "+373",
  },
  {
    id: 161,
    name: "Montenegro",
    code2: "ME",
    code3: "MNE",
    mobile_code: "+382",
  },
  {
    id: 162,
    name: "Saint Martin (French part)",
    code2: "MF",
    code3: "MAF",
    mobile_code: "+590",
  },
  {
    id: 163,
    name: "Madagascar",
    code2: "MG",
    code3: "MDG",
    mobile_code: "+261",
  },
  {
    id: 164,
    name: "Marshall Islands",
    code2: "MH",
    code3: "MHL",
    mobile_code: "+692",
  },
  {
    id: 166,
    name: "The Republic of North Macedonia",
    code2: "MK",
    code3: "MKD",
    mobile_code: "+389",
  },
  {
    id: 167,
    name: "Mali",
    code2: "ML",
    code3: "MLI",
    mobile_code: "+223",
  },
  {
    id: 168,
    name: "Myanmar",
    code2: "MM",
    code3: "MMR",
    mobile_code: "+95",
  },
  {
    id: 169,
    name: "Mongolia",
    code2: "MN",
    code3: "MNG",
    mobile_code: "+976",
  },
  {
    id: 170,
    name: "Macao",
    code2: "MO",
    code3: "MAC",
    mobile_code: "+853",
  },
  {
    id: 171,
    name: "Northern Mariana Islands",
    code2: "MP",
    code3: "MNP",
    mobile_code: "+1 670",
  },
  {
    id: 172,
    name: "Martinique",
    code2: "MQ",
    code3: "MTQ",
    mobile_code: "+596",
  },
  {
    id: 173,
    name: "Mauritania",
    code2: "MR",
    code3: "MRT",
    mobile_code: "+222",
  },
  {
    id: 174,
    name: "Montserrat",
    code2: "MS",
    code3: "MSR",
    mobile_code: "+1 664",
  },
  {
    id: 175,
    name: "Malta",
    code2: "MT",
    code3: "MLT",
    mobile_code: "+356",
  },
  {
    id: 176,
    name: "Mauritius",
    code2: "MU",
    code3: "MUS",
    mobile_code: "+230",
  },
  {
    id: 177,
    name: "Maldives",
    code2: "MV",
    code3: "MDV",
    mobile_code: "+960",
  },
  {
    id: 178,
    name: "Malawi",
    code2: "MW",
    code3: "MWI",
    mobile_code: "+265",
  },
  {
    id: 179,
    name: "Mexico",
    code2: "MX",
    code3: "MEX",
    mobile_code: "+52",
  },
  {
    id: 180,
    name: "Malaysia",
    code2: "MY",
    code3: "MYS",
    mobile_code: "+60",
  },
  {
    id: 181,
    name: "Mozambique",
    code2: "MZ",
    code3: "MOZ",
    mobile_code: "+258",
  },
  {
    id: 182,
    name: "Namibia",
    code2: "NA",
    code3: "NAM",
    mobile_code: "+264",
  },
  {
    id: 183,
    name: "New Caledonia",
    code2: "NC",
    code3: "NCL",
    mobile_code: "+687",
  },
  {
    id: 184,
    name: "Niger",
    code2: "NE",
    code3: "NER",
    mobile_code: "+227",
  },
  {
    id: 185,
    name: "Norfolk Island",
    code2: "NF",
    code3: "NFK",
    mobile_code: "+672",
  },
  {
    id: 186,
    name: "Nigeria",
    code2: "NG",
    code3: "NGA",
    mobile_code: "+234",
  },
  {
    id: 188,
    name: "Nicaragua",
    code2: "NI",
    code3: "NIC",
    mobile_code: "+505",
  },
  {
    id: 189,
    name: "Netherlands",
    code2: "NL",
    code3: "NLD",
    mobile_code: "+31",
  },
  {
    id: 190,
    name: "Norway",
    code2: "NO",
    code3: "NOR",
    mobile_code: "+47",
  },
  {
    id: 191,
    name: "Nepal",
    code2: "NP",
    code3: "NPL",
    mobile_code: "+977",
  },
  {
    id: 193,
    name: "Nauru",
    code2: "NR",
    code3: "NRU",
    mobile_code: "+674",
  },
  {
    id: 195,
    name: "Niue",
    code2: "NU",
    code3: "NIU",
    mobile_code: "+683",
  },
  {
    id: 196,
    name: "New Zealand",
    code2: "NZ",
    code3: "NZL",
    mobile_code: "+64",
  },
  {
    id: 197,
    name: "Oman",
    code2: "OM",
    code3: "OMN",
    mobile_code: "+968",
  },
  {
    id: 198,
    name: "Panama",
    code2: "PA",
    code3: "PAN",
    mobile_code: "+507",
  },
  {
    id: 200,
    name: "Peru",
    code2: "PE",
    code3: "PER",
    mobile_code: "+51",
  },
  {
    id: 201,
    name: "French Polynesia",
    code2: "PF",
    code3: "PYF",
    mobile_code: "+689",
  },
  {
    id: 202,
    name: "Papua New Guinea",
    code2: "PG",
    code3: "PNG",
    mobile_code: "+675",
  },
  {
    id: 203,
    name: "Philippines",
    code2: "PH",
    code3: "PHL",
    mobile_code: "+63",
  },
  {
    id: 204,
    name: "Pakistan",
    code2: "PK",
    code3: "PAK",
    mobile_code: "+92",
  },
  {
    id: 205,
    name: "Poland",
    code2: "PL",
    code3: "POL",
    mobile_code: "+48",
  },
  {
    id: 206,
    name: "Saint Pierre and Miquelon",
    code2: "PM",
    code3: "SPM",
    mobile_code: "+508",
  },
  {
    id: 207,
    name: "Pitcairn",
    code2: "PN",
    code3: "PCN",
    mobile_code: "+872",
  },
  {
    id: 208,
    name: "Puerto Rico",
    code2: "PR",
    code3: "PRI",
    mobile_code: "+1 787",
  },
  {
    id: 209,
    name: "State of Palestine",
    code2: "PS",
    code3: "PSE",
    mobile_code: "+970",
  },
  {
    id: 210,
    name: "Portugal",
    code2: "PT",
    code3: "PRT",
    mobile_code: "+351",
  },
  {
    id: 212,
    name: "Palau",
    code2: "PW",
    code3: "PLW",
    mobile_code: "+680",
  },
  {
    id: 213,
    name: "Paraguay",
    code2: "PY",
    code3: "PRY",
    mobile_code: "+595",
  },
  {
    id: 215,
    name: "Qatar",
    code2: "QA",
    code3: "QAT",
    mobile_code: "+974",
  },
  {
    id: 216,
    name: "Reunion",
    code2: "RE",
    code3: "REU",
    mobile_code: "+262",
  },
  {
    id: 218,
    name: "Romania",
    code2: "RO",
    code3: "ROU",
    mobile_code: "+40",
  },
  {
    id: 219,
    name: "Serbia",
    code2: "RS",
    code3: "SRB",
    mobile_code: "+381",
  },
  {
    id: 220,
    name: "Russian Federation",
    code2: "RU",
    code3: "RUS",
    mobile_code: "+7",
  },
  {
    id: 221,
    name: "Rwanda",
    code2: "RW",
    code3: "RWA",
    mobile_code: "+250",
  },
  {
    id: 222,
    name: "Saudi Arabia",
    code2: "SA",
    code3: "SAU",
    mobile_code: "+966",
  },
  {
    id: 223,
    name: "Solomon Islands",
    code2: "SB",
    code3: "SLB",
    mobile_code: "+677",
  },
  {
    id: 224,
    name: "Seychelles",
    code2: "SC",
    code3: "SYC",
    mobile_code: "+248",
  },
  {
    id: 225,
    name: "Sudan",
    code2: "SD",
    code3: "SDN",
    mobile_code: "+249",
  },
  {
    id: 226,
    name: "Sweden",
    code2: "SE",
    code3: "SWE",
    mobile_code: "+46",
  },
  {
    id: 227,
    name: "Singapore",
    code2: "SG",
    code3: "SGP",
    mobile_code: "+65",
  },
  {
    id: 228,
    name: "Saint Helena",
    code2: "SH",
    code3: "SHN",
    mobile_code: "+290",
  },
  {
    id: 229,
    name: "Slovenia",
    code2: "SI",
    code3: "SVN",
    mobile_code: "+386",
  },
  {
    id: 230,
    name: "Svalbard and Jan Mayen",
    code2: "SJ",
    code3: "SJM",
    mobile_code: "+47",
  },
  {
    id: 231,
    name: "Slovakia",
    code2: "SK",
    code3: "SVK",
    mobile_code: "+421",
  },
  {
    id: 232,
    name: "Slovakia",
    code2: "SK",
    code3: "SKM",
    mobile_code: "",
  },
  {
    id: 233,
    name: "Sierra Leone",
    code2: "SL",
    code3: "SLE",
    mobile_code: "+232",
  },
  {
    id: 234,
    name: "San Marino",
    code2: "SM",
    code3: "SMR",
    mobile_code: "+378",
  },
  {
    id: 235,
    name: "Senegal",
    code2: "SN",
    code3: "SEN",
    mobile_code: "+221",
  },
  {
    id: 236,
    name: "Somalia",
    code2: "SO",
    code3: "SOM",
    mobile_code: "+252",
  },
  {
    id: 237,
    name: "Suriname",
    code2: "SR",
    code3: "SUR",
    mobile_code: "+597",
  },
  {
    id: 238,
    name: "South Sudan",
    code2: "SS",
    code3: "SSD",
    mobile_code: "+211",
  },
  {
    id: 239,
    name: "Sao Tome and Principe",
    code2: "ST",
    code3: "STP",
    mobile_code: "+239",
  },
  {
    id: 241,
    name: "El Salvador",
    code2: "SV",
    code3: "SLV",
    mobile_code: "+503",
  },
  {
    id: 242,
    name: "Sint Maarten (Dutch part)",
    code2: "SX",
    code3: "SXM",
    mobile_code: "+1 721",
  },
  {
    id: 243,
    name: "Syrian Arab Republic",
    code2: "SY",
    code3: "SYR",
    mobile_code: "+963",
  },
  {
    id: 244,
    name: "Eswatini",
    code2: "SZ",
    code3: "SWZ",
    mobile_code: "+268",
  },
  {
    id: 246,
    name: "Turks and Caicos Islands",
    code2: "TC",
    code3: "TCA",
    mobile_code: "+1 649",
  },
  {
    id: 247,
    name: "Chad",
    code2: "TD",
    code3: "TCD",
    mobile_code: "+235",
  },
  {
    id: 248,
    name: "French Southern Territories",
    code2: "TF",
    code3: "ATF",
    mobile_code: "",
  },
  {
    id: 249,
    name: "Togo",
    code2: "TG",
    code3: "TGO",
    mobile_code: "+228",
  },
  {
    id: 250,
    name: "Thailand",
    code2: "TH",
    code3: "THA",
    mobile_code: "+66",
  },
  {
    id: 251,
    name: "Tajikistan",
    code2: "TJ",
    code3: "TJK",
    mobile_code: "+992",
  },
  {
    id: 252,
    name: "Tokelau",
    code2: "TK",
    code3: "TKL",
    mobile_code: "+690",
  },
  {
    id: 253,
    name: "Timor-Leste",
    code2: "TL",
    code3: "TLS",
    mobile_code: "+670",
  },
  {
    id: 254,
    name: "Turkmenistan",
    code2: "TM",
    code3: "TKM",
    mobile_code: "+993",
  },
  {
    id: 255,
    name: "Tunisia",
    code2: "TN",
    code3: "TUN",
    mobile_code: "+216",
  },
  {
    id: 256,
    name: "Tonga",
    code2: "TO",
    code3: "TON",
    mobile_code: "+676",
  },
  {
    id: 258,
    name: "Turkey",
    code2: "TR",
    code3: "TUR",
    mobile_code: "+90",
  },
  {
    id: 259,
    name: "Trinidad and Tobago",
    code2: "TT",
    code3: "TTO",
    mobile_code: "+1 868",
  },
  {
    id: 260,
    name: "Tuvalu",
    code2: "TV",
    code3: "TUV",
    mobile_code: "+688",
  },
  {
    id: 261,
    name: "Taiwan, Province of China",
    code2: "TW",
    code3: "TWN",
    mobile_code: "+886",
  },
  {
    id: 262,
    name: "United Republic of Tanzania",
    code2: "TZ",
    code3: "TZA",
    mobile_code: "+255",
  },
  {
    id: 263,
    name: "Ukraine",
    code2: "UA",
    code3: "UKR",
    mobile_code: "+380",
  },
  {
    id: 264,
    name: "Uganda",
    code2: "UG",
    code3: "UGA",
    mobile_code: "+256",
  },
  {
    id: 266,
    name: "United States Minor Outlying Islands",
    code2: "UM",
    code3: "UMI",
    mobile_code: "+1",
  },
  {
    id: 267,
    name: "United States of America",
    code2: "US",
    code3: "USA",
    mobile_code: "+1",
  },
  {
    id: 268,
    name: "Uruguay",
    code2: "UY",
    code3: "URY",
    mobile_code: "+598",
  },
  {
    id: 269,
    name: "Uzbekistan",
    code2: "UZ",
    code3: "UZB",
    mobile_code: "+998",
  },
  {
    id: 270,
    name: "Holy See (Vatican City State)",
    code2: "VA",
    code3: "VAT",
    mobile_code: "+379",
  },
  {
    id: 271,
    name: "Saint Vincent and the Grenadines",
    code2: "VC",
    code3: "VCT",
    mobile_code: "+1 784",
  },
  {
    id: 273,
    name: "Venezuela",
    code2: "VE",
    code3: "VEN",
    mobile_code: "+58",
  },
  {
    id: 274,
    name: "Virgin Islands, British",
    code2: "VG",
    code3: "VGB",
    mobile_code: "+1 284",
  },
  {
    id: 275,
    name: "Virgin Islands, U.S.",
    code2: "VI",
    code3: "VIR",
    mobile_code: "+1 340",
  },
  {
    id: 276,
    name: "Vietnam",
    code2: "VN",
    code3: "VNM",
    mobile_code: "+84",
  },
  {
    id: 277,
    name: "Vanuatu",
    code2: "VU",
    code3: "VUT",
    mobile_code: "+678",
  },
  {
    id: 278,
    name: "Wallis and Futuna",
    code2: "WF",
    code3: "WLF",
    mobile_code: "+681",
  },
  {
    id: 280,
    name: "Samoa",
    code2: "WS",
    code3: "WSM",
    mobile_code: "+685",
  },
  {
    id: 281,
    name: "Kosovo",
    code2: "XK",
    code3: "",
    mobile_code: "+383",
  },
  {
    id: 283,
    name: "Yemen",
    code2: "YE",
    code3: "YEM",
    mobile_code: "+967",
  },
  {
    id: 284,
    name: "Mayotte",
    code2: "YT",
    code3: "MYT",
    mobile_code: "+262",
  },
  {
    id: 286,
    name: "South Africa",
    code2: "ZA",
    code3: "ZAF",
    mobile_code: "+27",
  },
  {
    id: 287,
    name: "Zambia",
    code2: "ZM",
    code3: "ZMB",
    mobile_code: "+260",
  },
  {
    id: 289,
    name: "Zimbabwe",
    code2: "ZW",
    code3: "ZWE",
    mobile_code: "+263",
  },
];

export const nationalities = [
  {
    id: "1",
    name: "Afghan",
  },
  {
    id: "2",
    name: "Albanian",
  },
  {
    id: "3",
    name: "Algerian",
  },
  {
    id: "4",
    name: "Andorran",
  },
  {
    id: "5",
    name: "Angolan",
  },
  {
    id: "6",
    name: "Antiguan and Barbudan",
  },
  {
    id: "7",
    name: "Argentinian",
  },
  {
    id: "8",
    name: "Armenian",
  },
  {
    id: "9",
    name: "Australian",
  },
  {
    id: "10",
    name: "Austrian",
  },
  {
    id: "11",
    name: "Azerbaijani",
  },
  {
    id: "12",
    name: "Bahamian",
  },
  {
    id: "13",
    name: "Bahraini",
  },
  {
    id: "14",
    name: "Bangladeshi",
  },
  {
    id: "15",
    name: "Barbadian",
  },
  {
    id: "16",
    name: "Belarusian",
  },
  {
    id: "17",
    name: "Belgian",
  },
  {
    id: "18",
    name: "Belizean",
  },
  {
    id: "19",
    name: "Beninese",
  },
  {
    id: "20",
    name: "Bhutanese",
  },
  {
    id: "21",
    name: "Bolivian",
  },
  {
    id: "22",
    name: "Bosnian and Herzegovinian",
  },
  {
    id: "23",
    name: "Motswana (Botswanan)",
  },
  {
    id: "24",
    name: "Brazilian",
  },
  {
    id: "25",
    name: "Bruneian",
  },
  {
    id: "26",
    name: "Bulgarian",
  },
  {
    id: "27",
    name: "Burkinabé",
  },
  {
    id: "28",
    name: "Burundian",
  },
  {
    id: "29",
    name: "Cabo Verdean",
  },
  {
    id: "30",
    name: "Cambodian",
  },
  {
    id: "31",
    name: "Cameroonian",
  },
  {
    id: "32",
    name: "Canadian",
  },
  {
    id: "33",
    name: "Central African",
  },
  {
    id: "34",
    name: "Chadian",
  },
  {
    id: "35",
    name: "Chilean",
  },
  {
    id: "36",
    name: "Chinese",
  },
  {
    id: "37",
    name: "Colombian",
  },
  {
    id: "38",
    name: "Comorian",
  },
  {
    id: "39",
    name: "Congolese",
  },
  {
    id: "40",
    name: "Costa Rican",
  },
  {
    id: "41",
    name: "Croatian",
  },
  {
    id: "42",
    name: "Cuban",
  },
  {
    id: "43",
    name: "Cypriot",
  },
  {
    id: "44",
    name: "Czech",
  },
  {
    id: "45",
    name: "Congolese",
  },
  {
    id: "46",
    name: "Danish",
  },
  {
    id: "47",
    name: "Djiboutian",
  },
  {
    id: "48",
    name: "Dominican",
  },
  {
    id: "49",
    name: "Dominican",
  },
  {
    id: "50",
    name: "Ecuadorian",
  },
  {
    id: "51",
    name: "Egyptian",
  },
  {
    id: "52",
    name: "Salvadoran",
  },
  {
    id: "53",
    name: "Equatorial Guinean",
  },
  {
    id: "54",
    name: "Eritrean",
  },
  {
    id: "55",
    name: "Estonian",
  },
  {
    id: "56",
    name: "Swazi (Eswatini)",
  },
  {
    id: "57",
    name: "Ethiopian",
  },
  {
    id: "58",
    name: "Fijian",
  },
  {
    id: "59",
    name: "Finnish",
  },
  {
    id: "60",
    name: "French",
  },
  {
    id: "61",
    name: "Gabonese",
  },
  {
    id: "62",
    name: "Gambian",
  },
  {
    id: "63",
    name: "Georgian",
  },
  {
    id: "64",
    name: "German",
  },
  {
    id: "65",
    name: "Ghanaian",
  },
  {
    id: "66",
    name: "Greek",
  },
  {
    id: "67",
    name: "Grenadian",
  },
  {
    id: "68",
    name: "Guatemalan",
  },
  {
    id: "69",
    name: "Guinean",
  },
  {
    id: "70",
    name: "Guinea-Bissauan",
  },
  {
    id: "71",
    name: "Guyanese",
  },
  {
    id: "72",
    name: "Haitian",
  },
  {
    id: "73",
    name: "Vatican",
  },
  {
    id: "74",
    name: "Honduran",
  },
  {
    id: "75",
    name: "Hungarian",
  },
  {
    id: "76",
    name: "Icelander",
  },
  {
    id: "77",
    name: "Indian",
  },
  {
    id: "78",
    name: "Indonesian",
  },
  {
    id: "79",
    name: "Iranian",
  },
  {
    id: "80",
    name: "Iraqi",
  },
  {
    id: "81",
    name: "Irish",
  },
  {
    id: "82",
    name: "Israeli",
  },
  {
    id: "83",
    name: "Italian",
  },
  {
    id: "84",
    name: "Jamaican",
  },
  {
    id: "85",
    name: "Japanese",
  },
  {
    id: "86",
    name: "Jordanian",
  },
  {
    id: "87",
    name: "Kazakhstani",
  },
  {
    id: "88",
    name: "Kenyan",
  },
  {
    id: "89",
    name: "I-Kiribati",
  },
  {
    id: "90",
    name: "Kuwaiti",
  },
  {
    id: "91",
    name: "Kyrgyzstani",
  },
  {
    id: "92",
    name: "Laotian",
  },
  {
    id: "93",
    name: "Latvian",
  },
  {
    id: "94",
    name: "Lebanese",
  },
  {
    id: "95",
    name: "Mosotho (Lesothoan)",
  },
  {
    id: "96",
    name: "Liberian",
  },
  {
    id: "97",
    name: "Libyan",
  },
  {
    id: "98",
    name: "Liechtensteiner",
  },
  {
    id: "99",
    name: "Lithuanian",
  },
  {
    id: "100",
    name: "Luxembourger",
  },
  {
    id: "101",
    name: "Malagasy",
  },
  {
    id: "102",
    name: "Malawian",
  },
  {
    id: "103",
    name: "Malaysian",
  },
  {
    id: "104",
    name: "Maldivian",
  },
  {
    id: "105",
    name: "Malian",
  },
  {
    id: "106",
    name: "Maltese",
  },
  {
    id: "107",
    name: "Marshallese",
  },
  {
    id: "108",
    name: "Mauritanian",
  },
  {
    id: "109",
    name: "Mauritian",
  },
  {
    id: "110",
    name: "Mexican",
  },
  {
    id: "111",
    name: "Micronesian",
  },
  {
    id: "112",
    name: "Moldovan",
  },
  {
    id: "113",
    name: "Monégasque",
  },
  {
    id: "114",
    name: "Mongolian",
  },
  {
    id: "115",
    name: "Montenegrin",
  },
  {
    id: "116",
    name: "Moroccan",
  },
  {
    id: "117",
    name: "Mozambican",
  },
  {
    id: "118",
    name: "Burmese (Myanmar)",
  },
  {
    id: "119",
    name: "Namibian",
  },
  {
    id: "120",
    name: "Nauruan",
  },
  {
    id: "121",
    name: "Nepali",
  },
  {
    id: "122",
    name: "Dutch",
  },
  {
    id: "123",
    name: "New Zealander",
  },
  {
    id: "124",
    name: "Nicaraguan",
  },
  {
    id: "125",
    name: "Nigerien",
  },
  {
    id: "126",
    name: "Nigerian",
  },
  {
    id: "127",
    name: "North Korean",
  },
  {
    id: "128",
    name: "North Macedonian",
  },
  {
    id: "129",
    name: "Norwegian",
  },
  {
    id: "130",
    name: "Omani",
  },
  {
    id: "131",
    name: "Pakistani",
  },
  {
    id: "132",
    name: "Palauan",
  },
  {
    id: "133",
    name: "Palestinian",
  },
  {
    id: "134",
    name: "Panamanian",
  },
  {
    id: "135",
    name: "Papua New Guinean",
  },
  {
    id: "136",
    name: "Paraguayan",
  },
  {
    id: "137",
    name: "Peruvian",
  },
  {
    id: "138",
    name: "Filipino",
  },
  {
    id: "139",
    name: "Polish",
  },
  {
    id: "140",
    name: "Portuguese",
  },
  {
    id: "141",
    name: "Qatari",
  },
  {
    id: "142",
    name: "Romanian",
  },
  {
    id: "143",
    name: "Russian",
  },
  {
    id: "144",
    name: "Rwandan",
  },
  {
    id: "145",
    name: "Kittian and Nevisian",
  },
  {
    id: "146",
    name: "Saint Lucian",
  },
  {
    id: "147",
    name: "Vincentian",
  },
  {
    id: "148",
    name: "Samoan",
  },
  {
    id: "149",
    name: "San Marinese",
  },
  {
    id: "150",
    name: "Sao Tomean",
  },
  {
    id: "151",
    name: "Saudi",
  },
  {
    id: "152",
    name: "Senegalese",
  },
  {
    id: "153",
    name: "Serbian",
  },
  {
    id: "154",
    name: "Seychellois",
  },
  {
    id: "155",
    name: "Sierra Leonean",
  },
  {
    id: "156",
    name: "Singaporean",
  },
  {
    id: "157",
    name: "Slovak",
  },
  {
    id: "158",
    name: "Slovene",
  },
  {
    id: "159",
    name: "Solomon Islander",
  },
  {
    id: "160",
    name: "Somali",
  },
  {
    id: "161",
    name: "South African",
  },
  {
    id: "162",
    name: "South Korean",
  },
  {
    id: "163",
    name: "South Sudanese",
  },
  {
    id: "164",
    name: "Spanish",
  },
  {
    id: "165",
    name: "Sri Lankan",
  },
  {
    id: "166",
    name: "Sudanese",
  },
  {
    id: "167",
    name: "Surinamer",
  },
  {
    id: "168",
    name: "Swedish",
  },
  {
    id: "169",
    name: "Swiss",
  },
  {
    id: "170",
    name: "Syrian",
  },
  {
    id: "171",
    name: "Tajik",
  },
  {
    id: "172",
    name: "Tanzanian",
  },
  {
    id: "173",
    name: "Thai",
  },
  {
    id: "174",
    name: "Timorese",
  },
  {
    id: "175",
    name: "Togolese",
  },
  {
    id: "176",
    name: "Tongan",
  },
  {
    id: "177",
    name: "Trinidadian and Tobagonian",
  },
  {
    id: "178",
    name: "Tunisian",
  },
  {
    id: "179",
    name: "Turkish",
  },
  {
    id: "180",
    name: "Turkmen",
  },
  {
    id: "181",
    name: "Tuvaluan",
  },
  {
    id: "182",
    name: "Ugandan",
  },
  {
    id: "183",
    name: "Ukrainian",
  },
  {
    id: "184",
    name: "Emirati",
  },
  {
    id: "185",
    name: "British",
  },
  {
    id: "186",
    name: "American",
  },
  {
    id: "187",
    name: "Uruguayan",
  },
  {
    id: "188",
    name: "Uzbekistani",
  },
  {
    id: "189",
    name: "Ni-Vanuatu",
  },
  {
    id: "190",
    name: "Venezuelan",
  },
  {
    id: "191",
    name: "Vietnamese",
  },
  {
    id: "192",
    name: "Yemeni",
  },
  {
    id: "193",
    name: "Zambian",
  },
  {
    id: "194",
    name: "Zimbabwean",
  },
];

export const timezones = [
  { id: -12, name: "GMT-12:00" },
  { id: -11, name: "GMT-11:00" },
  { id: -10, name: "GMT-10:00" },
  { id: -9, name: "GMT-09:00" },
  { id: -8, name: "GMT-08:00" },
  { id: -7, name: "GMT-07:00" },
  { id: -6, name: "GMT-06:00" },
  { id: -5, name: "GMT-05:00" },
  { id: -4, name: "GMT-04:00" },
  { id: -3, name: "GMT-03:00" },
  { id: -2, name: "GMT-02:00" },
  { id: -1, name: "GMT-01:00" },
  { id: 0, name: "GMT" },
  { id: 1, name: "GMT+01:00" },
  { id: 2, name: "GMT+02:00" },
  { id: 3, name: "GMT+03:00" },
  { id: 4, name: "GMT+04:00" },
  { id: 5, name: "GMT+05:00" },
  { id: 6, name: "GMT+06:00" },
  { id: 7, name: "GMT+07:00" },
  { id: 8, name: "GMT+08:00" },
  { id: 9, name: "GMT+09:00" },
  { id: 10, name: "GMT+10:00" },
  { id: 11, name: "GMT+11:00" },
  { id: 12, name: "GMT+12:00" },
];

export const offsetNumber = 50;
// export const offsetNumber = 10;
